import {
  LOGIN_USER,
  LOGOUT_USER,
} from '../actions';

const INIT_STATE = {
  isLoggedIn: !!localStorage.getItem('refreshToken'),
  adminId: localStorage.getItem('adminId'),
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case LOGIN_USER:
      return {...state, isLoggedIn: true, adminId: action.adminId};
    case LOGOUT_USER:
      return {...state, isLoggedIn: false, adminId: null};
    default:
      return {...state};
  }
};
